export const environment = {
  production: false,
  API_URL: 'http://develop.omapi.dev.ov.sde',
  WS_API_URL: 'http://ws-develop.omapi.dev.ov.sde',
  // API_URL: 'http://localhost:55890',
  // WS_API_URL: 'http://localhost:55890',
  Version: '0.1',
  enableLogging: true,
};
